import antd, { Form, Collapse, Row, Col, PageHeader } from 'antd';
import styled from 'styled-components';
import ScreenHelper from './ScreenHelper';
import { ColSize } from 'antd/lib/col';

export const RightAlignRow = styled(Row)`
  text-align: right;
`;

export const LeftAlignRow = styled(Row)`
  text-align: left;
`;

export const CenterAlignRow = styled(Row)`
  text-align: center;
`;

export const centeredRowAttributes: { type: any; justify: any; align: any } = {
  type: 'flex',
  justify: 'center',
  align: 'middle',
};

declare type ColSpanType = ColSize;

export const PageContainerColLayout: { [key: string]: ColSpanType } = {
  xl: {
    span: 10,
    offset: 0,
  },
  lg: {
    span: 10,
    offset: 0,
  },
  md: {
    span: 12,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  xs: {
    span: 24,
    offset: 0,
  },
};

export const PageContainerRow = styled(Row)`
  ${ScreenHelper.up('lg', 'xl')`
     margin-top: 20px;
     padding-top: 10px;
    `}

  ${ScreenHelper.down('lg', 'sm')`
     margin-top: 10px;
     padding-top: 0px;
    `}
`;

export const PageContainerCol = styled(Col)`
  text-align: center;

  ${ScreenHelper.up('lg', 'xl')`
`}

  ${ScreenHelper.down('lg', 'sm')`
     padding-left: 0px;
     padding-right: 0px;
    `}
`;

export const PageTitle = styled(PageHeader)`
  &.ant-page-header {
    .ant-page-header-title-view {
      .ant-page-header-title-view-title {
        font-size: 2em;
      }
    }
    padding: 16px 24px 16px 0px;
    background-color: #f8f8f8;
  }
`;

export const TitleColSize: { [key: string]: ColSpanType } = {
  xxl: {
    span: 8,
    offset: 7,
  },
  xl: {
    span: 8,
    offset: 7,
  },
  lg: {
    span: 8,
    offset: 7,
  },
  md: {
    span: 8,
    offset: 6,
  },
  sm: {
    span: 20,
    offset: 2,
  },
  xs: {
    span: 20,
    offset: 2,
  },
};

export const TitleCol = styled(Col)`
`;

export const HeaderRow = styled(Row)`
  background-color: #f8f8f8;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const BorderlessCollapse = styled(Collapse)`
  border: 0px;

  div.ant-collapse-item {
    border: 0px;
  }
`;
